// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2J9IR","productName":"Table_productName__1_Bfs"};